(function () {
    'use strict';
    angular
        .module('tikonApp')
        .factory('MarketingCampaignCustom', MarketingCampaignCustom);

    MarketingCampaignCustom.$inject = ['$resource', 'ENV'];

    function MarketingCampaignCustom($resource,ENV) {


        var getAllCompanyMarketingCampaigns = function () {

            var resourceUrl = 'api/get-all-company-marketing-campaign';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET', isArray: true}
                }
            );
        };
         var getMarketingCampaigns = function () {

            var resourceUrl = 'api/_search/marketing-campaign';
            return $resource(resourceUrl, {}, {
                    'query': {method: 'GET'}
                }
            );
        };

        var getSmsPanelOverView = function () {
           var resourceUrl = 'api/marketing-campaign/get-sms-panel-overview';
           return $resource(resourceUrl, {}, {
               }
           );
       };



        return {
            getAllCompanyMarketingCampaigns: getAllCompanyMarketingCampaigns,
            getMarketingCampaigns: getMarketingCampaigns,
            getSmsPanelOverView:getSmsPanelOverView

        };
    }
})();
